import type { ApolloError } from '@apollo/client'
import type { Ref } from 'vue'

import type { Field, FieldKey, FormData } from '@/types/global'

const errors: Record<Field['type'], string> = {
  email: 'Please enter a valid email address.',
  date: 'Please enter a valid date.',
  password: 'Please enter a valid password.',
  searchable: 'Please enter a valid string format.',
  text: 'Please enter a valid string format.',
}

const validationRegex: Record<Field['type'], RegExp | null> = {
  email: /^[^\s\n]+@[^\s\n]+\.[a-z0-9]{2,}$/,
  date: null,
  password: /^.{8,}$/,
  searchable: null,
  text: null,
}

const validateField = (value: string, type: Field['type']) => {
  if (value !== '') {
    if (
      (validationRegex[type] !== null && validationRegex[type].test(value)) ||
      validationRegex[type] === null
    ) {
      return null
    }
    return errors[type]
  }

  return 'This field is required'
}

export const useForm = (form: Ref<FormData>) => {
  const handleMutationError = (e: ApolloError) => {
    const validationErrors = e.graphQLErrors[0]?.extensions?.validation
    if (validationErrors) {
      Object.entries(validationErrors).forEach(([key, value]) => {
        if (key.startsWith('input.')) {
          key = key.replace('input.', '')
        }

        if (form.value.fields[key as FieldKey]) {
          form.value.fields[key as FieldKey].error = value[0]
        }
      })

      updateFormValidity()
    }
  }

  const updateFormValidity = () => {
    form.value.valid = Object.values(form.value.fields).every((field) => {
      return !['', null].includes(field.value) && field.error === null
    })
  }

  const validate = (key: FieldKey) => {
    form.value.fields[key].error = validateField(
      form.value.fields[key].value,
      form.value.fields[key].type,
    )
    updateFormValidity()
  }

  return { handleMutationError, validate }
}
